export default {
  // api 根路径
  apiRoot: process.env.VUE_APP_API_ROOT,
};
